import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import ChartClinicalNoteReviewModal from "./ChartClinicalNoteReviewModal";
import ChartClinicalNoteItemDeleteModal from "./ChartClinicalNoteItemDeleteModal";

import Utils from "../../../../helpers/Utils";

import bindActions from "../../../../helpers/bindActions";
import { FULL_DATE_FORMAT } from "../../../../constants/Constants";

import clinicNoteItemTypes from "../../../../constants/chart-sidebar/clinicNoteItemTypes";
import * as simpleModalActions from "../../../../actions/simpleModalActions";
import { openSimpleModal } from "../../../../actions/simpleModalActions";
import * as chartSideClinicalNoteActions from "../../../../actions/chartSideClinicalNoteActions";
import { getCompanyFormatFullDate } from "../../../../helpers/DateUtils";
import { DoctorInfo } from "../../../doctor/DoctorInfo";
import { AppLayout } from "../../../app-layout/AppLayout";
import * as followUpActions from "../../../../actions/followUpActions";
import TransactionsTable from "../../../ui/TransactionsTable";

const isEditAvailable = (item, permissions = []) => {
  const less24hours = Date.now() - item.createdDate < 24 * 60 * 60 * 1000;
  const less48hours = Date.now() - item.createdDate < 48 * 60 * 60 * 1000;
  const less72hours = Date.now() - item.createdDate < 72 * 60 * 60 * 1000;

  const editPermission = permissions.indexOf("EDIT_CLINIC_NOTE_ITEM") >= 0;
  const editAllPermission = permissions.indexOf("EDIT_CLINIC_NOTE_ITEM_ALL") >= 0;
  const less24HourPermission = permissions.indexOf("EDIT_CLINIC_NOTE_ITEM_WITHIN_24_HOURS") >= 0;
  const less48HourPermission = permissions.indexOf("EDIT_CLINIC_NOTE_ITEM_WITHIN_48_HOURS") >= 0;
  const less72HourPermission = permissions.indexOf("EDIT_CLINIC_NOTE_ITEM_WITHIN_72_HOURS") >= 0;
  return !(
    editAllPermission ||
    editPermission ||
    (less48HourPermission && less48hours) ||
    (less24HourPermission && less24hours) ||
    (less72HourPermission && less72hours)
  );
};
const enhancer = connect(
  ({
    chartSideClinicalNote: { clinicalNoteActiveTab },
    followUp: { showClinicalNoteDetailSideBar },
  }) => ({
    clinicalNoteActiveTab,
    showClinicalNoteDetailSideBar,
  }),
  bindActions({ chartSideClinicalNoteActions, simpleModalActions, followUpActions }),
);

export default enhancer(
  class ChartClinicalNoteItemView extends React.Component {
    static propTypes = {
      clinic: PropTypes.object,
    };

    constructor(props) {
      super(props);

      this.state = {
        isReviewOpen: false,
        isExpanded: false,
      };
    }
    componentDidMount() {
      this.props.chartSideClinicalNoteActions.getItem();
      this.props.chartSideClinicalNoteActions.getCompletedTransactions(this.props.onAppointment);
    }

    editNote = () => {
      const { stack, item } = this.props.chartSideClinicalNote;
      const asAddendum = item.referenceClinicNoteId;
      if (asAddendum && this.props.permissions.indexOf("EDIT_CLINIC_NOTE_ITEM_ADDENDUM") === -1) {
        return this.props.simpleModalActions.openSimpleModal({
          body: "permission denied to edit reference note",
        });
      }

      if (isEditAvailable(item, this.props.permissions)) {
        return this.props.simpleModalActions.openSimpleModal({
          body: "permission denied",
        });
      }
      const stackItem = _.last(stack);
      const { id } = stackItem.item;

      const data = {
        id,
      };

      const writtenNote = !(item.noteTemplate && item.noteTemplate.name);

      if (writtenNote) {
        this.props.chartSideClinicalNoteActions.openTextarea(clinicNoteItemTypes.edit);
      } else {
        this.props.chartSideClinicalNoteActions.openItem(data, clinicNoteItemTypes.edit);
      }
    };

    reviewNoteHandler = () => {
      this.props.chartSideClinicalNoteActions.reviewClinicalNoteItem();
    };

    isDeleteAvailable = () => {
      const { permissions } = this.props;
      const deleteAllPermission = permissions.indexOf("REMOVE_CLINIC_NOTE_ITEM_ALL") >= 0;
      const deletePermission = permissions.indexOf("REMOVE_CLINIC_NOTE_ITEM") >= 0;
      return !(deleteAllPermission || deletePermission);
    };

    deleteNote = () => {
      if (this.isDeleteAvailable()) {
        return openSimpleModal({
          body: "permission denied",
        });
      }
      this.props.chartSideClinicalNoteActions.openDeleteModal();
    };

    onBackClick = () => {
      if (this.props.showClinicalNoteDetailSideBar) {
        this.props.followUpActions.clinicalNoteDetailSidebarShow(false);
      }
      this.props.chartSideClinicalNoteActions.popStack();
    };

    render() {
      const {
        item,
        deleteModalVisible,
        referenceList,
        clinicalNoteActiveTab,
        completedDiagnosisList,
        completedTreatmentList,
        fetchingCompletedDiagnosis,
        fetchingCompletedTreatments,
      } = this.props.chartSideClinicalNote;

      const drawenNote = item.typeCode === "NOTE_TYPE_IMAGE";
      const deletedNote =
        clinicalNoteActiveTab.code === "voidedNotes" || this.props.showClinicalNoteDetailSideBar;

      const asAddendum = item.referenceClinicNoteId;
      const reviewer = _.get(item, "reviewedMember", {});

      return (
        <>
          <AppLayout
            headerClassName="clinical-note-item-view-title"
            onBackClick={this.onBackClick}
            title={<div className="chart-number">#{item.patient && item.patient.chartNumber}</div>}
            rightComponent={<div className="name">{item.name}</div>}
          >
            <div className="chart-clinical-note">
              <div className="clinical-note-item">
                <div className="clinical-note-item-view-body">
                  <div className="clinical-note-item-view-details">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        Patient: <strong>{item.patient && item.patient.fullName}</strong>
                        &nbsp; Chart: <strong>#{item.patient && item.patient.chartNumber}</strong>
                      </div>
                      <button
                        className="btn btn-primary d-flex align-items-center col-gap-2"
                        onClick={() => this.setState({ isExpanded: !this.state.isExpanded })}
                      >
                        <span
                          className={`chevron-dx-trx ${this.state.isExpanded ? "--rotate" : ""}`}
                        >
                          &#9654;
                        </span>
                        {this.state.isExpanded ? "Hide" : "Show"} Trx + Dx
                      </button>
                    </div>
                    <div>
                      Created: &nbsp;
                      <strong>
                        {Utils.parseDateFormat(
                          Utils.calcDateWithTimeZone(item.createdDate),
                          FULL_DATE_FORMAT,
                        )}
                      </strong>
                    </div>
                    <div>
                      Age: <strong>{_.get(item, "patient.age")}</strong>
                    </div>
                    <div>
                      [Electronic Stamp] Name: <strong>{item.owner && item.owner.name}</strong>{" "}
                      License: <strong>{_.get(item, "owner.code")}</strong>
                    </div>
                  </div>
                  <TransactionsTable
                    isExpanded={this.state.isExpanded}
                    onAppointment={this.props.onAppointment}
                    completedDiagnosisList={completedDiagnosisList}
                    completedTreatmentList={completedTreatmentList}
                    fetchingCompletedDiagnosis={fetchingCompletedDiagnosis}
                    fetchingCompletedTreatments={fetchingCompletedTreatments}
                  />
                  <div
                    className="clinical-note-item-view-note"
                    style={{ display: this.state.isExpanded ? "none" : "block" }}
                  >
                    <div
                      dangerouslySetInnerHTML={{ __html: item.note }}
                      style={{ overflow: "auto" }}
                    />

                    {!!item.owner && (
                      <DoctorInfo doctor={item.owner} signature={item.doctorSignature} />
                    )}
                    {reviewer.name && (
                      <>
                        <div className="d-flex justify-content-around mt-4 mb-1">
                          <div>
                            Reviewed By: <strong>{reviewer.name}</strong>
                          </div>
                          <div>
                            Reviewed On:{" "}
                            <strong>
                              {item.modifiedDate
                                ? getCompanyFormatFullDate(item.modifiedDate)
                                : null}
                            </strong>
                          </div>
                        </div>

                        <DoctorInfo
                          doctor={reviewer}
                          signature={item.doctorSignature}
                          lineHide={true}
                        />
                      </>
                    )}
                    {referenceList.map((x) => (
                      <div key={x.id} className="d-flex flex-column mb-3">
                        <span className="font-weight-bold">{`[Addendum] ${
                          x.name
                        } ${getCompanyFormatFullDate(x.createdDate)}`}</span>
                        <div className="mt-1" dangerouslySetInnerHTML={{ __html: x.note }} />
                        <hr style={{ borderTopColor: "#000000", width: "100%" }} />
                      </div>
                    ))}
                    {(referenceList || []).length > 0 && (
                      <DoctorInfo
                        doctor={reviewer}
                        signature={item.doctorSignature}
                        lineHide={true}
                      />
                    )}
                  </div>
                </div>
                {!deletedNote && (
                  <div
                    className="clinical-note-item-view-footer"
                    style={{ display: this.state.isExpanded ? "none" : "block" }}
                  >
                    <div className="clearfix">
                      <div className="col-sm-4">
                        <button
                          disabled={drawenNote}
                          onClick={this.editNote}
                          className="btn btn-primary btn-lg btn-block"
                        >
                          {asAddendum ? "Edit Reference Note" : "Edit Note"}
                        </button>
                      </div>
                      <div className="col-sm-4">
                        <button
                          disabled={drawenNote}
                          onClick={() => this.setState({ isReviewOpen: true })}
                          className="btn btn-primary btn-lg btn-block"
                        >
                          Review
                        </button>
                      </div>
                      <div className="col-sm-4">
                        <button
                          onClick={this.deleteNote}
                          className="btn btn-primary btn-lg btn-block"
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </AppLayout>
          <ChartClinicalNoteItemDeleteModal
            deleteModalVisible={deleteModalVisible}
            closeDeleteModal={() => this.props.chartSideClinicalNoteActions.closeDeleteModal()}
            deleteItem={this.props.chartSideClinicalNoteActions.deleteItem}
          />
          <ChartClinicalNoteReviewModal
            closeReviewModal={() => this.setState({ isReviewOpen: false })}
            reviewModalVisible={this.state.isReviewOpen}
            clinicalNoteReview={this.reviewNoteHandler}
          />
        </>
      );
    }
  },
);
